// import axios from 'axios'
// import React, { useEffect, useState } from 'react'
// import { Box, Typography, Grid, Divider } from '@mui/material'
// import { styled } from '@mui/system'
// // import coinImage from './bitcoin.png';
// // import BlurText from "../Effects/BlurText";
// import './Statistic.css'

// const StatItem = ({ title, subtitle }: { title: string; subtitle: string }) => (
//   <Box textAlign='center' px={2}>
//     <Typography variant='h5' fontWeight='bold'>
//       {title}
//     </Typography>
//     <Typography variant='body2' mt={1}>
//       {subtitle}
//     </Typography>
//   </Box>
// )

// const DividerVertical = styled(Divider)(({ theme }) => ({
//   height: 60,
//   alignSelf: 'center',
//   [theme.breakpoints.down('sm')]: {
//     display: 'none',
//   },
//   backgroundColor: '#00DA33',
// }))

// const Statistic: React.FC = () => {
//   //   type ImageFormat = {
//   //   name: string;
//   //   hash: string;
//   //   ext: string;
//   //   mime: string;
//   //   path: string | null;
//   //   width: number;
//   //   height: number;
//   //   size: number;
//   //   sizeInBytes: number;
//   //   url: string;
//   // };

//   type GroupTextItem = {
//     id: number
//     big_txt: string
//     small_txt: string
//   }

//   const [groupText, setGroupText] = useState<GroupTextItem[]>([])
//   const [coinImage, setCoinImage] = useState<string>('')
//   const [mainText, setMainText] = useState<string>('Loading...')

//   useEffect(() => {
//     const fetchData = async () => {
//       const BASE_URL = 'https://app.dfopsa.online' // replace with your API base URL

//       try {
//         const res = await axios.get(
//           'https://app.dfopsa.online/api/statistic?populate=*'
//         )
//         console.log('Response:', res.data)
//         const coinImage = res?.data?.data?.img?.[0]?.formats?.thumbnail?.url
//           ? `${BASE_URL}${res?.data?.data?.img?.[0].formats.thumbnail.url}`
//           : ''
//         const mainText = res?.data?.data?.h1
//           ? `${res?.data?.data?.h1}`
//           : 'Loading...'
//         const groupTextData = res?.data?.data?.group_text || []
//         setCoinImage(coinImage)
//         setMainText(mainText)
//         setGroupText(groupTextData)
//       } catch (error) {
//         console.error('Failed to fetch statistic data:', error)
//       }
//     }

//     fetchData()
//   }, [])

//   return (
//     <>
//       <Box className='Statistic' py={10} textAlign='center'>
//         {/* Icon */}
//         {/*<Box mb={4}>*/}
//         {/*  {coinImage && (*/}
//         {/*    <img src={coinImage} alt="Bitcoin" width={120} height={120} />*/}
//         {/*  )}*/}
//         {/*</Box>*/}

//         {/* Title */}
//         <Typography variant='h2' fontWeight='bold'>
//           {mainText}
//         </Typography>

//         {/* Stats */}
//         <Grid
//           container
//           spacing={3}
//           justifyContent='center'
//           alignItems='center'
//           mt={5}
//         >
//           {groupText.map((item, index) => (
//             <React.Fragment key={item?.id}>
//               <Grid item>
//                 <StatItem title={item.big_txt} subtitle={item.small_txt} />
//               </Grid>
//               {index < groupText.length - 1 && (
//                 <DividerVertical orientation='vertical' flexItem />
//               )}
//             </React.Fragment>
//           ))}
//         </Grid>
//       </Box>
//     </>
//   )
// }

// export default Statistic

import axios from 'axios'
import React, { useEffect, useState, useRef } from 'react'
import { Box, Typography, Grid, Divider } from '@mui/material'
import { styled } from '@mui/system'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import './Statistic.css'

gsap.registerPlugin(ScrollTrigger)

const StatItem = ({ title, subtitle }: { title: string; subtitle: string }) => (
  <Box textAlign='center' px={2} className='stat-item'>
    <Typography variant='h5' fontWeight='bold'>
      {title}
    </Typography>
    <Typography variant='body2' mt={1}>
      {subtitle}
    </Typography>
  </Box>
)

const DividerVertical = styled(Divider)(({ theme }) => ({
  height: 60,
  alignSelf: 'center',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
  backgroundColor: '#00DA33',
}))

const Statistic: React.FC = () => {
  type GroupTextItem = {
    id: number
    big_txt: string
    small_txt: string
  }

  const [groupText, setGroupText] = useState<GroupTextItem[]>([])

  const [mainText, setMainText] = useState<string>('Loading...')

  const titleRef = useRef<HTMLDivElement>(null)
  const statsRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const fetchData = async () => {
      const BASE_URL = 'https://app.dfopsa.online'
      try {
        const res = await axios.get(
          'https://app.dfopsa.online/api/statistic?populate=*'
        )
        const coinImage = res?.data?.data?.img?.[0]?.formats?.thumbnail?.url
          ? `${BASE_URL}${res?.data?.data?.img?.[0].formats.thumbnail.url}`
          : ''
        const mainText = res?.data?.data?.h1
          ? `${res?.data?.data?.h1}`
          : 'Loading...'
        const groupTextData = res?.data?.data?.group_text || []

        setMainText(mainText)
        setGroupText(groupTextData)
      } catch (error) {
        console.error('Failed to fetch statistic data:', error)
      }
    }

    fetchData()
  }, [])

  // GSAP анимация: сначала заголовок, потом по очереди элементы
  useEffect(() => {
    if (!titleRef.current || !statsRef.current) return

    gsap.fromTo(
      titleRef.current,
      { opacity: 0, y: 40 },
      {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: titleRef.current,
          start: 'top 80%',
          toggleActions: 'play none none reverse',
        },
        onComplete: () => {
          if (!statsRef.current) return
          gsap.fromTo(
            statsRef.current.querySelectorAll(
              '.stat-item, .MuiDivider-vertical'
            ),
            { opacity: 0, y: 60 },
            {
              opacity: 1,
              y: 0,
              duration: 0.8,
              stagger: 0.15,
              ease: 'power3.out',
              delay: 0.1,
              scrollTrigger: {
                trigger: statsRef.current,
                start: 'top 80%',
                toggleActions: 'play none none reverse',
              },
            }
          )
        },
      }
    )
  }, [groupText, mainText])

  return (
    <Box
      className='Statistic'
      sx={{ p: { xs: '40px 0 80px', md: '80px 0' } }}
      textAlign='center'
    >
      {/* Title */}
      <Typography
        variant='h2'
        fontWeight='bold'
        ref={titleRef}
        sx={{ display: 'inline-block', fontSize: { xs: 36, md: 40 } }}
      >
        {mainText}
      </Typography>

      {/* Stats */}
      <Grid
        container
        spacing={3}
        justifyContent='center'
        alignItems='center'
        sx={{ mt: { xs: 0, md: 5 } }}
        ref={statsRef}
      >
        {groupText.map((item, index) => (
          <React.Fragment key={item?.id}>
            <Grid item>
              <StatItem title={item.big_txt} subtitle={item.small_txt} />
            </Grid>
            {index < groupText.length - 1 && (
              <DividerVertical orientation='vertical' flexItem />
            )}
          </React.Fragment>
        ))}
      </Grid>
    </Box>
  )
}

export default Statistic
